export const EVENT_OPEN_MODAL = 'open_mail_subscription';
export const MAX_WIDTH_MODAL = '390px';
